// src/Dashboard/pages/user/FicheAdherent/components/AdherentTabs.jsx

import React from "react";
import {
  FaCalendarCheck,
  FaClipboardList,
  FaFileAlt,
  FaIdCard,
  FaMedal,
  FaMoneyCheckAlt,
  FaShoppingBag,
  FaTrophy,
  FaUserCog,
  FaUsers,
} from "react-icons/fa";

export const ADHERENT_TABS = [
  { id: "profil", label: "Profil", icon: FaIdCard },
  { id: "groupes", label: "Groupes", icon: FaUsers },
  { id: "gestionnaires", label: "Gestionnaires", icon: FaUserCog },
  { id: "ceintures", label: "Ceintures", icon: FaMedal },
  { id: "competitions", label: "Compétitions", icon: FaTrophy },
  { id: "palmares", label: "Palmarès", icon: FaMedal },
  { id: "dossier", label: "Dossier", icon: FaFileAlt },
  { id: "reglement", label: "Règlement", icon: FaClipboardList },
  { id: "achats", label: "Achats", icon: FaShoppingBag },
  { id: "presences", label: "Présences", icon: FaCalendarCheck },
];

export default function AdherentTabs({ activeTab, onChange }) {
  return (
    <div className="flex gap-2 overflow-x-auto rounded-2xl bg-slate-100 p-2 dark:bg-slate-900">
      {ADHERENT_TABS.map((tab) => {
        const Icon = tab.icon;
        const active = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange?.(tab.id)}
            className={[
              "inline-flex shrink-0 items-center justify-center gap-2 rounded-xl px-3 py-2 text-xs font-bold transition sm:text-sm",
              active
                ? "bg-white text-violet-700 shadow-sm ring-1 ring-slate-200 dark:bg-slate-950 dark:text-violet-300 dark:ring-slate-800"
                : "text-slate-600 hover:bg-white/70 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white",
            ].join(" ")}
          >
            <Icon className="text-sm" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}